import { AssistantComposerSuggestions } from "@/components/assistant/AssistantComposerSuggestions";
import {
  getWriteApprovalRevisionSuggestions,
  type WriteApprovalEntityKind,
} from "@/components/assistant/formatWriteApprovalSummary";
import { useMemo } from "react";

type Props = {
  kind: WriteApprovalEntityKind;
  proposal: Record<string, unknown>;
  disabled?: boolean;
  onSelectSuggestion: (text: string) => void;
};

export function AssistantPendingProposalComposerExtras({
  kind,
  proposal,
  disabled,
  onSelectSuggestion,
}: Props) {
  const suggestions = useMemo(
    () => getWriteApprovalRevisionSuggestions(kind, proposal),
    [kind, proposal]
  );

  return (
    <AssistantComposerSuggestions
      suggestions={suggestions}
      disabled={disabled}
      onSelect={onSelectSuggestion}
    />
  );
}
